import { render, staticRenderFns } from "./GerenciarAplicacoes.vue?vue&type=template&id=d4c5835a&scoped=true"
import script from "./GerenciarAplicacoes.vue?vue&type=script&lang=js"
export * from "./GerenciarAplicacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c5835a",
  null
  
)

export default component.exports